"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERelativeTimeTypes = exports.EReservationPeriodType = exports.EWeekdaySelection = exports.EWeekdays = void 0;
var EWeekdays;
(function (EWeekdays) {
    EWeekdays["MON"] = "MON";
    EWeekdays["TUE"] = "TUE";
    EWeekdays["WED"] = "WED";
    EWeekdays["THU"] = "THU";
    EWeekdays["FRI"] = "FRI";
    EWeekdays["SAT"] = "SAT";
    EWeekdays["SUN"] = "SUN";
})(EWeekdays = exports.EWeekdays || (exports.EWeekdays = {}));
var EWeekdaySelection;
(function (EWeekdaySelection) {
    EWeekdaySelection["noWeekDaySelection"] = "no_weekday_selection";
})(EWeekdaySelection = exports.EWeekdaySelection || (exports.EWeekdaySelection = {}));
var EReservationPeriodType;
(function (EReservationPeriodType) {
    EReservationPeriodType["NONE"] = "NONE";
    EReservationPeriodType["RESERVATION_PERIOD"] = "RESERVATION_PERIOD";
    EReservationPeriodType["DAY"] = "DAY";
    EReservationPeriodType["WEEK"] = "WEEK";
    EReservationPeriodType["MONTH"] = "MONTH";
    EReservationPeriodType["YEAR"] = "YEAR";
})(EReservationPeriodType = exports.EReservationPeriodType || (exports.EReservationPeriodType = {}));
var ERelativeTimeTypes;
(function (ERelativeTimeTypes) {
    ERelativeTimeTypes["DAYS"] = "DAYS";
    ERelativeTimeTypes["HOURS"] = "HOURS";
    ERelativeTimeTypes["MINUTES"] = "MINUTES";
})(ERelativeTimeTypes = exports.ERelativeTimeTypes || (exports.ERelativeTimeTypes = {}));
